import { render, staticRenderFns } from "./PendingEmailVerificationBanner.vue?vue&type=template&id=f9dc0ee8"
import script from "./PendingEmailVerificationBanner.vue?vue&type=script&lang=js"
export * from "./PendingEmailVerificationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports